// LICENSE_CODE ZON
'use strict';

/*jslint browser:true, es6:true, node:true, react:true*/
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useRef, useEffect, useState, useLayoutEffect } from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import _ from 'zutil';
import hopt from 'hola_opt';
import zutil from '/util/util.js';
import { get_icon, use_scrolled, is_scrolled_down } from '../ui_utils.js';
import { use_screen } from '../lib/screen_util.ts';
import { Sitepic } from '../unblock/sitepic.js';
import styles from './popular_sitepics.module.less';
var cols_count = {
  xs: 2,
  sm: 3,
  md: 4,
  lg: 5,
  xl: 5
};
var get_vars_object = (props, cols) => {
  var row_gap = props.row_gap,
    col_gap = props.col_gap;
  var n_style_vars = {
    '--count_col': cols,
    '--opacity_val': 1
  };
  if (row_gap) n_style_vars['--row_gap'] = `${row_gap}px`;
  if (col_gap) n_style_vars['--col_gap'] = `${col_gap}px`;
  return n_style_vars;
};
var with_promotions = (sitepics, promotions) => {
  var result = sitepics.slice();
  promotions.filter(({
    show
  }) => show).forEach(({
    pos,
    promo
  }, i) => {
    result.splice(pos + i, 0, {
      promo
    });
  });
  return result;
};
var Popular_sitepics = props => {
  useTranslation();
  var limit = props.limit,
    sitepics = props.sitepics,
    sitepics_generic = props.sitepics_generic,
    _props$promotions = props.promotions,
    promotions = _props$promotions === void 0 ? [] : _props$promotions,
    add_on_scroll = props.add_on_scroll,
    active = props.active,
    header = props.header,
    _props$on_get_more = props.on_get_more,
    on_get_more = _props$on_get_more === void 0 ? _.noop : _props$on_get_more,
    img_load_delay = props.img_load_delay,
    activate = props.activate,
    filter = props.filter,
    row_gap = props.row_gap,
    col_gap = props.col_gap,
    cls = props.cls,
    with_column = props.with_column,
    scale = props.scale,
    elem = props.elem,
    requester = props.requester,
    no_more_button = props.no_more_button,
    page = props.page;
  var Item_el = elem || Sitepic;
  var items = with_promotions(sitepics, promotions);
  var _use_screen = use_screen(),
    screen = _use_screen.screen,
    is_client = _use_screen.is_client;
  var cols = (props.cols_count || cols_count)[screen];
  var siteicon = zutil.get(hopt, 'www_hola.siteicon.enabled');
  var icon_sources = [link => get_icon(link, siteicon, sitepics_generic && requester)];
  var t_ref = useRef();
  var _use_scrolled = use_scrolled(),
    direction = _use_scrolled.direction,
    _use_scrolled$y = _use_scrolled.y,
    y = _use_scrolled$y === void 0 ? 0 : _use_scrolled$y;
  useEffect(() => {
    if (!add_on_scroll || limit >= items.length || direction == 'up') return;
    if (t_ref && is_scrolled_down(t_ref.current, 100)) on_get_more();
  }, [y]);
  useEffect(() => {
    if (!scale || !t_ref.current) return;
    t_ref.current.style.transform = `scale(${scale})`;
    t_ref.current.style.transformOrigin = '0 0';
  }, [t_ref.current, scale]);
  var use_isomorphic_layout_effect = is_client ? useLayoutEffect : useEffect;
  use_isomorphic_layout_effect(() => {
    if (!scale || !t_ref.current || limit < 10) return;
    var h = t_ref.current.getBoundingClientRect().height;
    t_ref.current.style.marginBottom = `-${h * (1 - scale)}px`;
  }, [limit, scale]);
  var _useState = useState(with_column ? get_vars_object(props, cols) : {}),
    _useState2 = _slicedToArray(_useState, 2),
    style_vars = _useState2[0],
    set_style_vars = _useState2[1];
  useEffect(() => set_style_vars(get_vars_object(props, cols)), [cols, row_gap, col_gap]);
  return /*#__PURE__*/React.createElement("div", {
    className: cn(styles.wrapper, cls)
  }, /*#__PURE__*/React.createElement("div", {
    className: cn(styles.grid, header && styles.with_header),
    ref: t_ref,
    style: style_vars
  }, header && /*#__PURE__*/React.createElement("div", {
    className: styles.header
  }, header), items.map((s, i) => {
    if (s.promo) {
      return /*#__PURE__*/React.createElement(Item_el, {
        key: `${i}-promo`,
        promo: s.promo,
        is_generic: sitepics_generic,
        requester: true
      });
    }
    if (!filter && !add_on_scroll && limit <= items.length && i == limit && !no_more_button) {
      return /*#__PURE__*/React.createElement(Item_el, {
        title: "More",
        more: true,
        filter: true,
        key: `${i}-more`,
        on_get_more: on_get_more,
        cls: styles.tile,
        is_generic: sitepics_generic,
        requester: true
      });
    }
    if (i > limit) return null;
    var unblocking = active && active.link == s.link;
    return /*#__PURE__*/React.createElement(Item_el, _extends({
      key: `${i}-${s.name}`
    }, s, {
      is_generic: sitepics_generic,
      requester: true,
      page: page,
      img_load_delay: img_load_delay || 100,
      activate: activate,
      unblocking: unblocking,
      cls: styles.tile,
      disabled: active && !unblocking,
      icon_sources: icon_sources
    }));
  })));
};
export { Popular_sitepics };